import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { ComponentDefinition, IApiConfiguration, IErrorReporting, IFrequencyValidationRule, JsonConfiguration, KeyValuePair, TimeUnit } from '../../../../models';
import { IConfigurationService, ILoggerService, IStoreActionsService } from '../../../../services';

class ApiParametersController implements angular.IComponentController {
    configuration: IApiConfiguration;
    errors: IErrorReporting[];
    formController: angular.IFormController;
    isLoading: boolean;
    jsonConfiguration: JsonConfiguration;
    timeUnits: KeyValuePair<TimeUnit, string>[];
    validationRules: IFrequencyValidationRule[];

    private _pristine: string;
    private _jsonPristine: string;

    static $inject = [
        '$q',
        '$state',
        'storeActionsService',
        'configurationService',
        'translatedLoggerService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _$state: StateService,
        private _storeActionsService: IStoreActionsService,
        private _configurationService: IConfigurationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.timeUnits = [
            { key: TimeUnit.Minute, value: 'Minute' },
            { key: TimeUnit.Hour, value: 'Hour' },
            { key: TimeUnit.Day, value: 'Day' },
            { key: TimeUnit.Week, value: 'Week' },
            { key: TimeUnit.Month, value: 'Month' },
            { key: TimeUnit.Year, value: 'Year' }
        ];
        this.validationRules = [
            {
                key: 'min',
                isValid: (frequency) => {
                    return frequency.interval > 0;
                },
            }
        ];

        this.errors = [
            {
                propertyName: 'notificationsRetentionTimeProperty',
                messages: [
                    { key: 'required', value: 'Notifications retention time is required' },
                    { key: 'min', value: 'Notifications retention time must be greater than 0' },
                ]
            }
        ];

        this.isLoading = true;
        this._$q.all([
            this._configurationService.getApiConfiguration(),
            this._configurationService.getJsonConfiguration(),
        ])
            .then(responses => {
                this._pristine = JSON.stringify(responses[0]);
                this._jsonPristine = JSON.stringify(responses[1]);
                this.resetWorkingCopy();
            })
            .finally(() => this.isLoading = false);
    }

    cancel() {
        this.resetWorkingCopy();
    }

    save() {
        this.isLoading = true;
        this._$q.all([
            this._configurationService.setApiConfiguration(this.configuration),
            this._configurationService.setJsonConfiguration(this.jsonConfiguration)
        ])
            .then(responses => {
                this._pristine = JSON.stringify(responses[0]);
                this._jsonPristine = JSON.stringify(responses[1]);
                this.resetWorkingCopy();
                this._loggerService.logSuccess('API configuration saved. You will now be logged out.');
                return this._storeActionsService.authentication.logout();
            })
            .then(() => {
                this._$state.go('login');
            })
            .catch(reason => {
                console.error(reason);
                this._loggerService.logError('Configuration has not been saved');
            })
            .finally(() => this.isLoading = false);
    }

    private resetWorkingCopy() {
        this.configuration = Object.assign({}, JSON.parse(this._pristine));
        this.jsonConfiguration = JSON.parse(this._jsonPristine);
        this.formController?.$setPristine();
    }
}

export const wtApiParameters: ComponentDefinition = {
    componentId: 'wtApiParameters',
    controller: ApiParametersController,
    template: require('./apiParameters.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};